import INTERNAL_LINKS from '../../../enums/InternalLinks';
import EducationContractorsList from '../../../pages/EducationContractors/List';

import { CustomButton } from '../../../components';
import { Avatar, Card, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { PlusOutlined, ReadOutlined } from '@ant-design/icons';
const { Title, Paragraph } = Typography;

const NaturalPersonFormEducationSection = ({
  readOnly = false,
  personID,
  divRef,
}) => {
  return (
    <Card
      size={'small'}
      bordered={false}
      title={
        <Title level={3}>
          <Avatar
            size={32}
            icon={<ReadOutlined />}
            style={{ backgroundColor: '#20b2aa', color: 'white' }}
            shape="square"
          />{' '}
          Educación
        </Title>
      }
    >
      <div ref={divRef}>
        <Paragraph>
          Recuerde que solo debe agregar la información relacionada con el
          quehacer de Corpoeducación (información que considere relevante) de la
          más reciente a la más antigua, de lo contrario dicha información puede
          ser eliminada de la plataforma.
        </Paragraph>
        {!readOnly && (
          <CustomButton
            type={'default'}
            className={'ant-btn-info'}
            htmlType="button"
            text={
              <Link to={`${INTERNAL_LINKS.EDUCATION_CONTRACTORS}/${personID}`}>
                <PlusOutlined /> Agregar educación
              </Link>
            }
          />
        )}
        <EducationContractorsList idTercero={personID} readOnly={readOnly} />
      </div>
    </Card>
  );
};

export default NaturalPersonFormEducationSection;
